import { navigate } from 'hookrouter';
import React from 'react';
import styled from 'styled-components';

export const Link = styled.a`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: #4957f4;
  margin: 15px 0px;
  align-self: flex-start;
  text-decoration: none;
  cursor: pointer;

  &:focus {
    outline-width: 1px;
    outline-style: solid;
    outline-offset: 2px;
    outline-color: #4957f4;
  }
`;

export const NavigationLink = ({
  path,
  children,
  onClick,
  onMouseDown,
  ...props
}: {
  className?: string;
  onClick?: () => void;
  onMouseDown?: () => void;
  children: React.ReactNode | React.ReactNodeArray;
  path: string;
}) => {
  return (
    <Link
      href='#'
      data-testid='navigation-link'
      {...props}
      onClick={e => {
        e.preventDefault();
        onClick && onClick();
        navigate(path);
      }}
      onMouseDown={e => {
        e.preventDefault();
        onMouseDown && onMouseDown();
        navigate(path);
      }}
    >
      {children}
    </Link>
  );
};
